import React, { Component } from 'react'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import DataTable from '../../../../DataTable/DataTable'
import { withTranslate } from 'react-redux-multilingual'
import { Scrollbars } from 'react-custom-scrollbars'
import NoDataDisplay from '../../../../NoDataDisplay/NoDataDisplay'
import _ from 'lodash/core'
// import Aux from '../../../../../hoc/Auxiliary/Auxiliary'

class ForceRankTable extends Component {
  state = {
    adjustData: [],
    gradeData: [],
    data: [],
    filterData: [],
    adjust: [],
    chart: [],
    updateChart: [],
    valid: false,
    adjust_grade: {
      label: 'Adjust Grade',
      elementType: 'newselect',
      elementConfig: {
        type: 'text',
        placeholder: 'Adjust Grade',
        options: [],
        clearDisabled: true
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data !== state.data) {
      let Data = props.data
      let adjust = []
      let adjust_option = []
      let chart = []
      chart = props.gradeData.map(grade => ({
        adjust_grade: grade.value_list_name,
        total: Data[grade.value_list_name]?.length || 0
      }))
      Object.entries(Data).reduce((updatedData, data) => {
        let [dataKey, dataAttrs] = data
        adjust_option.push({ key: dataKey, value: dataKey, label: dataKey })
        // chart.push({ adjust_grade: dataKey, total: dataAttrs.length })
        dataAttrs.map(attrs => {
          adjust.push({
            ...attrs,
            grade: dataKey,
            adjust_grade: dataKey,
            no: adjust.length + 1,
            emp_name: attrs.emp_detail.emp.full_name,
            org_name: attrs.emp_detail.org.org_name,
            level_name: attrs.emp_detail.level.level_name,
            level_group: attrs.emp_detail.level?.level_group?.level_group_name,
            position_name: attrs.emp_detail.position?.position_name
          })
          return attrs
        })
        return data
      }, {})
      let adjust_grade = state.adjust_grade
      props.adjust_grade(chart)
      props.valid(true)
      props.dataAdjust(adjust)
      return {
        data: props.data,
        adjust: adjust,
        chart: chart,
        updateChart: chart,
        adjust_grade: {
          ...adjust_grade,
          elementConfig: {
            ...adjust_grade.elementConfig,
            options: adjust_option
          }
        }
      }
    }
    return null
  }

  gradeChanged = (rowData, e) => {
    let oldGrade = ''
    let update = this.state.adjust.map(item => {
      if (item === rowData) {
        oldGrade = item.adjust_grade
        return {
          ...item,
          adjust_grade: e.key
        }
      } else {
        return item
      }
    })

    let updateChart = this.state.updateChart.map(item => {
      if (oldGrade !== e.key) {
        if (item.adjust_grade === e.key) {
          return {
            ...item,
            total: item.total + 1
          }
        } else if (item.adjust_grade === oldGrade) {
          return {
            ...item,
            total: item.total - 1
          }
        } else {
          return item
        }
      } else {
        return item
      }
    })
    this.props.adjust_grade(updateChart)
    // this.props.valid_count(this.checkGrade())
    // validate
    let valid = true
    updateChart.map(up => {
      this.state.chart.map(ol => {
        if (up.adjust_grade === ol.adjust_grade) {
          valid = valid && up.total === ol.total
        }
        return ol
      })
      return up
    })
    this.props.dataAdjust(update)

    this.props.valid(valid)
    this.setState({
      adjust: update,
      updateChart: updateChart,
      valid: valid
    })

    this.checkGrade()
  }

  // checkGrade = () => {
  //   this.props.checkGrade = () => {
  //     return _.isEqual(this.state.chart, this.state.updateChart)
  //   }
  // }

  checkGrade = () => {
    if (this.props.checkGrade) {
      let checkGrade = _.isEqual(this.state.chart, this.state.updateChart)
      this.props.checkGrade(checkGrade)
    }
  }

  // checkGrade = () => {
  //   let totalChart = 0
  //   this.state.chart.map(item => {
  //     totalChart = totalChart + item.total
  //     return item
  //   })
  //   let totalUpdateChart = 0
  //   this.state.updateChart.map(item => {
  //     totalUpdateChart = totalUpdateChart + item.total
  //     return item
  //   })
  //
  //   return totalUpdateChart === totalChart
  // }
  structureForIndex = [
    { field: 'emp_name', title: this.props.translate('employeeName'), type: 'string' },
    { field: 'org_name', title: this.props.translate('organizationName'), type: 'string' },
    { field: 'level_name', title: this.props.translate('level'), type: 'string' },
    { field: 'level_group', title: this.props.translate('levelGroup'), type: 'string' },
    { field: 'position_name', title: this.props.translate('position'), type: 'string' },
    { field: 'force_rank_index', title: this.props.translate('forceRankIndex'), type: 'string' },
    { field: 'no', title: this.props.translate('no'), type: 'string' },
    { field: 'grade', title: this.props.translate('grade'), type: 'string' },
    {
      field: 'adjust_grade',
      title: this.props.translate('adjust'),
      render: rowData => {
        return (
          <div>
            <InputGroup
              inputType={'newselect'}
              noMargin
              label={''}
              inputValue={{
                key: rowData.adjust_grade,
                value: rowData.adjust_grade,
                label: rowData.adjust_grade
              }}
              configs={this.state.adjust_grade?.elementConfig}
              changed={e => this.gradeChanged(rowData, e)}
            />
          </div>
        )
      },
      width: 100
    }
  ]

  render() {
    let table = <NoDataDisplay />
    if (this.state.adjust.length !== 0) {
      table = (
        <DataTable
          data={this.state.adjust}
          loading={this.props.loading}
          tableTitle={this.props.translate('adjustGradeTable')}
          structure={this.structureForIndex}
          paginationDisabled={true}
          rowActions={this.rowActions}
        />
      )
    }

    return (
      <Scrollbars autoHide style={{ height: '400px', maxHeight: '400px' }}>
        {table}
      </Scrollbars>
    )
  }
}

export default withTranslate(ForceRankTable)
